
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexABELdL8Hxql8xamayjKNyc2LVDA0avsp_gwa0PtX73kMeta } from "/workspace/source/artist-center.idus.com/pages/index.vue?macro=true";
import { default as addtzTJAw2afdBpW4vpa7SH0QbXQv8PGmB6J227GTBPqTgMeta } from "/workspace/source/artist-center.idus.com/pages/artist/add.vue?macro=true";
import { default as loginZsb0MizzadGPdpQkE6K1HahqmGVwYa4mE5AoLU8kMi8Meta } from "/workspace/source/artist-center.idus.com/pages/auth/login.vue?macro=true";
import { default as logouth6pqtiIczO_VlF_45mCPJ5cjXttcNOCSvvCDGqqm_45mPHsMeta } from "/workspace/source/artist-center.idus.com/pages/auth/logout.vue?macro=true";
import { default as indexy86txeHc4dgxSQDYbrln1TCUQTwk_45Z0Gpcy_45XK6HFCwMeta } from "/workspace/source/artist-center.idus.com/pages/artist/index.vue?macro=true";
import { default as indexoMfzjDcKzH5o9FAQzm5bHmc_PRS1ts7a_gQxNbXDeYoMeta } from "/workspace/source/artist-center.idus.com/pages/auth/join/index.vue?macro=true";
import { default as successF_45w9Cuzh6EuOx_vQ4DMeSXIQFBHW3sLhC6eUShOSndUMeta } from "/workspace/source/artist-center.idus.com/pages/auth/join/success.vue?macro=true";
import { default as change_45passwordGWu5ZkXRqdhNJcigqxxt5ucRJ4vYU1B_F9tangSwv3cMeta } from "/workspace/source/artist-center.idus.com/pages/auth/change-password.vue?macro=true";
import { default as okV5P4iRhyUGUT1GsWk2QBkDiEu3hQx1vsQcaMMMvrFjAMeta } from "/workspace/source/artist-center.idus.com/pages/auth/verification/ok.vue?macro=true";
import { default as close2cgpPSd8vOwxPBgUOyQfGtjI4cDFH3hBRPqyoj_45WXDgMeta } from "/workspace/source/artist-center.idus.com/pages/auth/verification/close.vue?macro=true";
import { default as indexeFUEMpSiXU6jMKCeuCAgC8HjzqBZoFvxVTBTwVXsM6sMeta } from "/workspace/source/artist-center.idus.com/pages/auth/verification/index.vue?macro=true";
export default [
  {
    name: indexABELdL8Hxql8xamayjKNyc2LVDA0avsp_gwa0PtX73kMeta?.name ?? "index",
    path: "/",
    meta: indexABELdL8Hxql8xamayjKNyc2LVDA0avsp_gwa0PtX73kMeta || {},
    component: () => import("/workspace/source/artist-center.idus.com/pages/index.vue")
  },
  {
    name: addtzTJAw2afdBpW4vpa7SH0QbXQv8PGmB6J227GTBPqTgMeta?.name ?? "artist-add",
    path: "/artist/add",
    meta: addtzTJAw2afdBpW4vpa7SH0QbXQv8PGmB6J227GTBPqTgMeta || {},
    component: () => import("/workspace/source/artist-center.idus.com/pages/artist/add.vue")
  },
  {
    name: loginZsb0MizzadGPdpQkE6K1HahqmGVwYa4mE5AoLU8kMi8Meta?.name ?? "auth-login",
    path: "/auth/login",
    meta: loginZsb0MizzadGPdpQkE6K1HahqmGVwYa4mE5AoLU8kMi8Meta || {},
    component: () => import("/workspace/source/artist-center.idus.com/pages/auth/login.vue")
  },
  {
    name: "auth-logout",
    path: "/auth/logout",
    meta: logouth6pqtiIczO_VlF_45mCPJ5cjXttcNOCSvvCDGqqm_45mPHsMeta || {},
    component: () => import("/workspace/source/artist-center.idus.com/pages/auth/logout.vue")
  },
  {
    name: indexy86txeHc4dgxSQDYbrln1TCUQTwk_45Z0Gpcy_45XK6HFCwMeta?.name ?? "artist",
    path: "/artist",
    meta: indexy86txeHc4dgxSQDYbrln1TCUQTwk_45Z0Gpcy_45XK6HFCwMeta || {},
    component: () => import("/workspace/source/artist-center.idus.com/pages/artist/index.vue")
  },
  {
    name: indexoMfzjDcKzH5o9FAQzm5bHmc_PRS1ts7a_gQxNbXDeYoMeta?.name ?? "auth-join",
    path: "/auth/join",
    meta: indexoMfzjDcKzH5o9FAQzm5bHmc_PRS1ts7a_gQxNbXDeYoMeta || {},
    component: () => import("/workspace/source/artist-center.idus.com/pages/auth/join/index.vue")
  },
  {
    name: successF_45w9Cuzh6EuOx_vQ4DMeSXIQFBHW3sLhC6eUShOSndUMeta?.name ?? "auth-join-success",
    path: "/auth/join/success",
    meta: successF_45w9Cuzh6EuOx_vQ4DMeSXIQFBHW3sLhC6eUShOSndUMeta || {},
    component: () => import("/workspace/source/artist-center.idus.com/pages/auth/join/success.vue")
  },
  {
    name: change_45passwordGWu5ZkXRqdhNJcigqxxt5ucRJ4vYU1B_F9tangSwv3cMeta?.name ?? "auth-change-password",
    path: "/auth/change-password",
    meta: change_45passwordGWu5ZkXRqdhNJcigqxxt5ucRJ4vYU1B_F9tangSwv3cMeta || {},
    component: () => import("/workspace/source/artist-center.idus.com/pages/auth/change-password.vue")
  },
  {
    name: "auth-verification-ok",
    path: "/auth/verification/ok",
    meta: okV5P4iRhyUGUT1GsWk2QBkDiEu3hQx1vsQcaMMMvrFjAMeta || {},
    component: () => import("/workspace/source/artist-center.idus.com/pages/auth/verification/ok.vue")
  },
  {
    name: "auth-verification-close",
    path: "/auth/verification/close",
    meta: close2cgpPSd8vOwxPBgUOyQfGtjI4cDFH3hBRPqyoj_45WXDgMeta || {},
    component: () => import("/workspace/source/artist-center.idus.com/pages/auth/verification/close.vue")
  },
  {
    name: "auth-verification",
    path: "/auth/verification",
    meta: indexeFUEMpSiXU6jMKCeuCAgC8HjzqBZoFvxVTBTwVXsM6sMeta || {},
    component: () => import("/workspace/source/artist-center.idus.com/pages/auth/verification/index.vue")
  }
]